import { LandingPage } from "zudoku/components";
import {
  BookUserIcon,
  MessageSquareIcon,
  PhoneIcon,
  SparklesIcon,
  WebhookIcon,
  ZapIcon,
} from "zudoku/icons";

import { DESCRIPTION } from "../src/registry.js";

// Mirrors the capability bullets on the Introduction page, each linking to where that
// capability starts.
const features = [
  {
    icon: <PhoneIcon />,
    title: "Calls and call data",
    description:
      "Query detailed call logs for reporting, real-time analytics, or writing back into customer records.",
    href: "/api/calls",
  },
  {
    icon: <MessageSquareIcon />,
    title: "Conversations",
    description:
      "Send and manage SMS and WhatsApp messages that land in the user's conversations in the Spoke app.",
    href: "/api/conversations",
  },
  {
    icon: <BookUserIcon />,
    title: "Unified Directory",
    description:
      "Sync CRM contacts and SIP trunk extensions for enhanced caller ID and real-time availability.",
    href: "/api/directory",
  },
  {
    icon: <WebhookIcon />,
    title: "Webhook events",
    description:
      "Subscribe to call and conversation events so your systems are notified as they happen.",
    href: "/webhook-events",
  },
  {
    icon: <ZapIcon />,
    title: "Data Actions",
    description:
      "Customise call and conversation workflows with your own logic at the moments that matter.",
    href: "/data-action-concepts",
  },
  {
    icon: <SparklesIcon />,
    title: "Content Analysis",
    description:
      "Run Spoke Enlighten AI over call recordings and transcripts to analyse every conversation.",
    href: "/api/content-analysis",
  },
];

export const LandingHero = () => (
  <LandingPage
    eyebrow="Spoke Developer API"
    title="Mobile-first conversations that move your business"
    description={DESCRIPTION}
    actions={[
      { label: "Get started", href: "/introduction" },
      { label: "API Reference", href: "/api", variant: "outline" },
    ]}
    features={features}
  />
);
